const AttributesViewController = () => import('./Controller')
const GroupView = () => import('./AttributesGroupView')
import SpecialOffersForm from '@app/SpecialOffers/Form'

export default function install(Vue) {
  Vue.component('AttributesViewController', AttributesViewController)
  Vue.component('GroupView', GroupView)
  Vue.component('SpecialOffersForm', SpecialOffersForm)
}
